import { combineReducers } from "redux";

import employeeReducer from "./employee/reducer";
import adminReducer from "./admin/reducer";
import notificationReducer from "./notification/reducer";
import supportReducer from "./support/reducer";

const reducers = combineReducers({
  employeeReducer,
  adminReducer,
  notificationReducer,
  supportReducer,
});

export default reducers;
